"use strict";
import React, { useEffect } from 'react';
import PropTypes from "prop-types";

export function CsfFournisseurRecognitionBeforeBeginningModal({ popupType, cancelRedirectUrl, urlRequestRecognition }) {

  /* Show a modal before beginning a new request or a renewal, on step 1
  */

  function handleCancelModal() {
    // navigate to previous page
    window.location.href = cancelRedirectUrl;
  }

  useEffect(() => {
    /* to open bootstrap modal: issue referring Modal otherwise in this context */
    document.getElementById('BtnOpenModalCsfBeforeBegin').click();
  }, []);


  return (
    <div>

      <div className="modal fade" id="CsfPreRecognitionInfoModal" tabIndex="-1"
        role="dialog"
        aria-labelledby="CsfPreRecognitionInfoModalTitle" aria-hidden="true">
        <div
          className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h2 id="CsfPreRecognitionInfoModalTitle">
                {popupType === 'renewal' ? (
                  window.Drupal.t('fournisseur.recognition.before-beginning-modal.renewal.title')
                ) : (
                  window.Drupal.t('fournisseur.recognition.before-beginning-modal.new.title')
                )}
              </h2>

              <button type="button" className="close" data-dismiss="modal"
                aria-label={window.Drupal.t('lang.modal.close')}>
                <i className="icon icon-csf-close-noborder"><span
                  className="d-none">&nbsp;</span></i>
              </button>
            </div>

            <div className="modal-body">
              <div className={`prereq-content ${popupType === 'renewal' && 'prereq-content-renewal'}`}>
                {popupType === 'renewal' ? (
                  <h3>{window.Drupal.t('fournisseur.recognition.before-beginning-modal-renewal.contenttitle')}</h3>
                ) : (
                  <h3>{window.Drupal.t('fournisseur.recognition.before-beginning-modal.contenttitle')}</h3>
                )}

                {popupType === 'renewal' ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.recognition.before-beginning-modal-renewal.body', {'@urlReco' : urlRequestRecognition, '@urlHome' : cancelRedirectUrl + '?modalModification=true'}) }}></div>
                ) : (
                  <div
                    dangerouslySetInnerHTML={{ __html: window.Drupal.t('fournisseur.recognition.before-beginning-modal.body') }}></div>
                )}
              </div>
            </div>

            <div className="modal-footer d-flex justify-content-between">
              <button type="button"
                className='button btn-outlined btn-larger'
                onClick={handleCancelModal} >
                {window.Drupal.t('fournisseur.back.btn')}
              </button>
              <button type="button"
                className='button btn-larger'
                data-dismiss="modal"
              >
                {window.Drupal.t('fournisseur.recognition.before-beginning-modal.continue.btn')}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* hidden button used only to open Bootstrap Modal programmatically in this context. */}
      <button
        id="BtnOpenModalCsfBeforeBegin"
        className="hidden"
        type="button"
        data-toggle="modal"
        data-target="#CsfPreRecognitionInfoModal">
      </button>

    </div>
  );
}

CsfFournisseurRecognitionBeforeBeginningModal.propTypes = {
  popupType: PropTypes.string,
  cancelRedirectUrl: PropTypes.string,
  urlRequestRecognition: PropTypes.string,
};
